var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8V6H4V8H20ZM20 12H4V18H15V20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V6C2 4.89 2.89 4 4 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V13H20V12Z",
    fill: "#FFBA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22V21C24 19.672 21.328 19 20 19C18.672 19 16 19.672 16 21V22H24ZM20 14C19.4696 14 18.9609 14.2107 18.5858 14.5858C18.2107 14.9609 18 15.4696 18 16C18 16.2626 18.0517 16.5227 18.1522 16.7654C18.2528 17.008 18.4001 17.2285 18.5858 17.4142C18.9609 17.7893 19.4696 18 20 18C20.2626 18 20.5227 17.9483 20.7654 17.8478C21.008 17.7472 21.2285 17.5999 21.4142 17.4142C21.5999 17.2285 21.7473 17.008 21.8478 16.7654C21.9483 16.5227 22 16.2626 22 16C22 15.7374 21.9483 15.4773 21.8478 15.2346C21.7473 14.992 21.5999 14.7715 21.4142 14.5858C21.2285 14.4001 21.008 14.2528 20.7654 14.1522C20.5227 14.0517 20.2626 14 20 14Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.b9a630384e3ae4ea2be64eeff2162a61.svg";
export { ForwardRef as ReactComponent };